export default () => {
  window.location.href = `${process.env.BASE_URL}`;
  return null;
};
